module.exports = __webpack_public_path__ + "static/img/2.c18c071.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/2.png
// module id = +7Fs
// module chunks = 4